import { FeatureFlagsManager } from "@core/features-flags/feature-flags.manager";

export const featureFactory = (featureFlagsManager:FeatureFlagsManager) => () => featureFlagsManager.loadConfig()